module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/swimmer.svg?7abc61eb96beca5b7cb0a435be6e5ba9";